import script from "./BusinessHallBJMbdc.vue?vue&type=script&setup=true&lang=ts"
export * from "./BusinessHallBJMbdc.vue?vue&type=script&setup=true&lang=ts"

import "./BusinessHallBJMbdc.vue?vue&type=style&index=0&id=07e4df2f&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e4df2f"]])

export default __exports__